export default __webpack_public_path__ + "static/media/dphns_small_thumbnail_website_1.9cae3a56.jpg";